<template>
  <finstar-layout>
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
  </finstar-layout>
</template>

<script>
import FinstarLayout from './components/FinstarLayout'

export default {
  name: 'App',
  components: {
    FinstarLayout,
  },
}
</script>
